import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { baseUrl } from '../Data/service/global.service';
import {
  CurrenciesResponse,
  CurrencyDto,
  CurrentExchangeRatesData,
  CurrentExchangeRatesResponse,
  ExchangeConvertRequest,
  ExchangeConvertResponse,
  ExchangeRateDto,
  ExchangeRateResponse,
} from '../models/currency.model';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  constructor(private http: HttpClient) {}

  /** GET /currencies — active currencies only */
  getActiveCurrencies(): Observable<CurrencyDto[]> {
    return this.http.get<CurrenciesResponse>(`${baseUrl}currencies`).pipe(
      map((res) => (res.data ?? []).filter((c) => c.is_active)),
    );
  }

  /** GET /exchange-rates?currency=&date= */
  getExchangeRate(currency: string, date?: string): Observable<ExchangeRateResponse> {
    let params = new HttpParams().set('currency', currency);
    if (date) {
      params = params.set('date', date);
    }
    return this.http.get<ExchangeRateResponse>(`${baseUrl}exchange-rates`, { params });
  }

  /** GET /exchange-rates/current — latest rates for dashboard / stats */
  getCurrentExchangeRates(): Observable<CurrentExchangeRatesData> {
    return this.http.get<CurrentExchangeRatesResponse>(`${baseUrl}exchange-rates/current`).pipe(
      map((res) => res.data ?? { base_currency_code: 'ILS', as_of: '', rates: [] }),
    );
  }

  /** POST /exchange-rates/convert — live conversion for UI display */
  convertAmounts(body: ExchangeConvertRequest): Observable<ExchangeConvertResponse> {
    return this.http.post<ExchangeConvertResponse>(`${baseUrl}exchange-rates/convert`, body);
  }
}
